import { Fragment } from 'react'
import RichText from 'components/common/richText'
import { LinkButton, GeneralLink } from 'components/common/typography'
import { Section, ConditionalDiv, AutoSwiper } from 'components/common/common_styles'
import { SwiperSlide } from 'swiper/react'
import { useInView } from 'react-intersection-observer'
import GImage from 'components/common/gImage'
import { MainContainer, TextOuterWrapper, TextContainer, ImageCaption, ImageWrapper, ImageCaptionNumber, ImageCaptionText } from './experience_styles'

const Experience = ({ data, black = false }) => {
  const { ref, inView } = useInView()

  return (
    <Section black={inView ? black : false} >
      <MainContainer padTop={[5, 3]} padBottom={[4, 3]} padLeft={[true, false]}>
        <TextOuterWrapper ref={ref}>
          <TextContainer title={data.primary.title} black={inView ? black : false}>
            <RichText data={data.primary.copy} />
            {data.primary.button_title &&
              <LinkButton link={data.primary.button_link} $white={inView ? black : false}>{data.primary.button_title}</LinkButton>
            }
          </TextContainer>
        </TextOuterWrapper>
        <ConditionalDiv desktopOnly>
          {data.items.map((item, index) =>
            <ImageBlock key={item.title} item={item} index={index} black={black} />
          )}
        </ConditionalDiv>
        <ConditionalDiv mobileOnly>
          <AutoSwiper
            slidesPerView='auto'
            spaceBetween={16}
            centeredSlides={true}
          >
            {data.items.map((item, index) =>
              <SwiperSlide key={item.title}>
                <ImageBlock item={item} index={index} black={black} />
              </SwiperSlide>
            )}
          </AutoSwiper>
        </ConditionalDiv>
      </MainContainer>
    </Section>
  )
}

export default Experience

const ImageBlock = ({ item, index, black }) => {
  const { ref, inView } = useInView()
  const isBlack = inView ? black : false

  return (
    <>
      <GeneralLink link={item.link} noUnderline aria-label={item.title}>
        <ImageWrapper inView={inView} offset={index} ref={ref}>
          <GImage data={item.image} />
        </ImageWrapper>
      </GeneralLink>
      <ImageCaption black={isBlack} inView={inView} offset={index}>
        <ImageCaptionNumber variant='h2' black={isBlack} aria-disabled={true}>{String(index + 1).padStart(2, '0')}</ImageCaptionNumber>
        <ImageCaptionText variant='h4' black={isBlack}>{item.title}</ImageCaptionText>
      </ImageCaption>
    </>
  )
}
